import { useQuery } from '@tanstack/react-query';
import { UseFormReturn } from 'react-hook-form';

import { apiV1GetTwinsDiscover, QueryV1GetTwinsDiscover } from '@/modules/api';

export const useQueryPersonalizedAis = ({
  enabled,
  form,
  onSuccess,
}: {
  enabled: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
  onSuccess?: (data: QueryV1GetTwinsDiscover) => void;
}) => {
  useQuery({
    enabled,
    queryFn: apiV1GetTwinsDiscover,
    queryKey: [apiV1GetTwinsDiscover.requestKey],
    staleTime: Infinity,
    onSuccess: (data) => {
      form.setValue('characters', data.twins);

      onSuccess && onSuccess(data);
    },
    retry(failureCount) {
      if (failureCount < 3) {
        return true;
      }
      return false;
    },
  });
};
